import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ProjectUIHelpers";

const ProjectUIContext = createContext();

export function useProjectUIContext() {
  return useContext(ProjectUIContext);
}

export const ProjectUIConsumer = ProjectUIContext.Consumer;

export function ProjectUIProvider({ projectUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initProject = {
    name: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initProject,
    newProjectButtonClick: projectUIEvents.newProjectButtonClick,
    openEditProjectPage: projectUIEvents.openEditProjectPage,
    openManageProjectPage: projectUIEvents.openManageProjectPage,
  };

  return (
    <ProjectUIContext.Provider value={value}>
      {children}
    </ProjectUIContext.Provider>
  );
}
